(() => {
  const initialize = (root) => {
    if (root.dataset.kkTargetReady === "true") return;
    root.dataset.kkTargetReady = "true";

    const cards = [...root.querySelectorAll("[data-kk-product]")];
    const filterButtons = [...root.querySelectorAll("[data-kk-filter]")];
    const count = root.querySelector("[data-kk-count]");
    const modal = root.querySelector("[data-kk-modal]");
    const modalImage = root.querySelector("[data-kk-modal-image]");
    const modalRole = root.querySelector("[data-kk-modal-role]");
    const modalName = root.querySelector("[data-kk-modal-name]");
    const modalCode = root.querySelector("[data-kk-modal-code]");
    const modalCopy = root.querySelector("[data-kk-modal-copy]");
    const closeButton = root.querySelector("[data-kk-modal-close]");
    const previousButton = root.querySelector("[data-kk-modal-prev]");
    const nextButton = root.querySelector("[data-kk-modal-next]");

    let activeIndex = 0;
    let lastFocusedElement = null;

    const updateModal = () => {
      const card = cards[activeIndex];
      if (!card) return;
      modalImage.src = card.dataset.kkImage;
      modalImage.alt = `${card.dataset.kkName} KISSKIND iced coffee cups`;
      modalRole.textContent = card.dataset.kkRole;
      modalName.textContent = card.dataset.kkName;
      modalCode.textContent = card.dataset.kkCode;
      modalCopy.textContent = card.dataset.kkStory;
    };

    const openModal = (index, trigger) => {
      activeIndex = index;
      lastFocusedElement = trigger || document.activeElement;
      updateModal();
      modal.hidden = false;
      document.body.classList.add("kk-target-modal-open");
      closeButton.focus();
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove("kk-target-modal-open");
      if (lastFocusedElement) lastFocusedElement.focus();
    };

    const stepModal = (direction) => {
      activeIndex = (activeIndex + direction + cards.length) % cards.length;
      updateModal();
    };

    cards.forEach((card, index) => {
      const trigger = card.querySelector("[data-kk-open-product]");
      trigger?.addEventListener("click", () => openModal(index, trigger));
    });

    root.querySelectorAll("[data-kk-swatch-index]").forEach((swatch) => {
      swatch.addEventListener("click", () => {
        const index = Number(swatch.dataset.kkSwatchIndex);
        openModal(index, swatch);
      });
    });

    filterButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const filter = button.dataset.kkFilter;
        let visibleCount = 0;
        filterButtons.forEach((item) => {
          item.setAttribute("aria-pressed", item === button ? "true" : "false");
        });
        cards.forEach((card) => {
          const visible = filter === "all" || card.dataset.kkTier === filter;
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        count.textContent = `Showing ${visibleCount} ${visibleCount === 1 ? "color" : "colors"}`;
      });
    });

    closeButton?.addEventListener("click", closeModal);
    previousButton?.addEventListener("click", () => stepModal(-1));
    nextButton?.addEventListener("click", () => stepModal(1));
    modal?.addEventListener("click", (event) => {
      if (event.target === modal) closeModal();
    });

    document.addEventListener("keydown", (event) => {
      if (modal.hidden) return;
      if (event.key === "Escape") closeModal();
      if (event.key === "ArrowLeft") stepModal(-1);
      if (event.key === "ArrowRight") stepModal(1);
    });
  };

  const boot = () => {
    document.querySelectorAll("[data-kk-target-native]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
